import lb from '@/lib/loopback';


export function statusDoAcervo(settings = {}) {
  return lb
    .post('/Relatorios/status-do-acervo', settings);
}

export function productivity(settings = {}) {
  return lb
    .post('/Relatorios/produtividade', settings);
}

export function keyWords(settings = {}) {
  return lb
    .post('/Relatorios/palavras-chave', settings);
}

export function documental(settings = {}) {
  return lb
    .post('/Relatorios/documental', settings);
}

export function documentDate(settings = {}) {
  return lb
    .post('/Relatorios/data-do-documento', settings);
}

export function search(settings = {}) {
  return lb
    .post('/Relatorios/consulta', settings);
}

export default {
  statusDoAcervo,
  productivity,
  keyWords,
  documental,
  documentDate,
  search,
};
